var _path, _rect, _g, _rect2, _rect3, _ellipse, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 17.5C21.8333 23.1149 17.2816 27.6667 11.6667 27.6667C6.05177 27.6667 1.5 23.1149 1.5 17.5C1.5 11.8851 6.05177 7.33337 11.6667 7.33337C17.2816 7.33337 21.8333 11.8851 21.8333 17.5Z",
    fill: "url(#paint0_linear_32915_4549)",
    stroke: "#FF4B4B",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 3.66663,
    width: 3,
    height: 2.33333,
    fill: "#FF4B4B",
    stroke: "#FF4B4B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32915_4549)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0.5,
    width: 8,
    height: 3.33333,
    rx: 1,
    fill: "#1CB0F6"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1895,
    y: 8.40468,
    width: 0.808118,
    height: 1.34686,
    transform: "rotate(45 20.1895 8.40468)",
    fill: "#FF4B4B",
    stroke: "#FF4B4B",
    strokeWidth: 0.808118
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5703,
    y: 5.16663,
    width: 4.84871,
    height: 2.69373,
    rx: 1,
    transform: "rotate(45 20.5703 5.16663)",
    fill: "#1CB0F6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.3333,
    cy: 31.5,
    rx: 11.3333,
    ry: 1,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5L12 17.5L14.5 20",
    stroke: "#052050",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32915_4549",
    x: 6,
    y: 0.5,
    width: 12,
    height: 7.33337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2375 0 0 0 0 0.23651 0 0 0 0 0.23651 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32915_4549"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32915_4549",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32915_4549",
    x1: 17.3177,
    y1: 43.2796,
    x2: 26.3861,
    y2: 35.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0544214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.9ca79f51a90dc5398fe54f0e2e2b5dab.svg";
export { ForwardRef as ReactComponent };